module.exports = __webpack_public_path__ + "static/media/relaxing.4ec9b814.png";